// src/components/legal/LegalDocumentPage.jsx
// Copyright (c) 2025 Nebularis Holdings LLC
// See IP License Agreement for usage restrictions.

import React, { useEffect } from "react";

import LegalDocumentRenderer from "./LegalDocumentRenderer";
import { getLegalDocument } from "./legalDocuments";
import "./LegalDocument.css";

export default function LegalDocumentPage({
  documentKey,
  onModeChange = null,
}) {
  const document = getLegalDocument(documentKey);

  useEffect(() => {
    if (!document || typeof window === "undefined") return undefined;

    const previousTitle = window.document.title;
    window.document.title = `${document.title} | OASYS`;

    return () => {
      window.document.title = previousTitle;
    };
  }, [document]);

  if (!document) {
    return (
      <div className="oasys-page-canvas legal-page">
        <div className="oasys-page-shell legal-page__shell">
          <section className="oasys-alert oasys-alert--warning">
            <div className="oasys-alert__content">
              <h1 className="oasys-alert__title">Legal document unavailable</h1>
              <p className="oasys-alert__message">
                The requested OASYS legal document could not be resolved.
              </p>
            </div>
          </section>
        </div>
      </div>
    );
  }

  const canReturnToTrust = typeof onModeChange === "function";

  return (
    <div className="oasys-page-canvas legal-page">
      <div className="oasys-page-shell legal-page__shell">
        <header className="oasys-page-header legal-page__header">
          <div className="oasys-page-header__content">
            <div className="legal-page__brand-row">
              <div className="legal-page__brand">
                <img src="/oasys-auth-logo-v2.png" alt="OASYS logo" className="legal-page__logo" />
                <div>
                  <div className="oasys-eyebrow">{document.eyebrow}</div>
                  <div className="legal-page__brand-name">OASYS Solutions</div>
                </div>
              </div>

              {canReturnToTrust ? (
                <button
                  type="button"
                  className="oasys-button oasys-button--medium oasys-button--secondary"
                  onClick={() => onModeChange("trust")}
                >
                  <span className="oasys-button__label">Back to Trust Center</span>
                </button>
              ) : null}
            </div>

            <h1 className="oasys-page-header__title">{document.title}</h1>
            <p className="oasys-page-header__description legal-page__description">
              {document.description}
            </p>
          </div>
        </header>

        <div className="oasys-section oasys-section--comfortable legal-page__document-shell">
          <LegalDocumentRenderer document={document} />
        </div>

        <footer className="legal-page__footer">
          <span>Budd Hub LLC d/b/a OASYS Solutions</span>
          <span aria-hidden="true">•</span>
          <a href="mailto:legal@oasyshq.com">legal@oasyshq.com</a>
        </footer>
      </div>
    </div>
  );
}
